/**
 * Persistence for the user's last-used Venue id, read by the `/` landing resolver and
 * written whenever a Venue is chosen or switched (ADR 0015). localStorage is best-effort:
 * a blocked or unavailable store degrades to "no last-used venue", never throws.
 */
const STORAGE_KEY = 'amuze.lastVenueId';

export function readLastVenueId(): string | null {
  try {
    return globalThis.localStorage?.getItem(STORAGE_KEY) ?? null;
  } catch {
    return null;
  }
}

export function writeLastVenueId(venueId: string): void {
  try {
    globalThis.localStorage?.setItem(STORAGE_KEY, venueId);
  } catch {
    // Storage unavailable (private mode, quota); landing simply won't be sticky.
  }
}
